if (!customElements.get("m-image-comparison")) {
  class MImageComparison extends HTMLElement {
    constructor() {
      super();

      this.active = false;
      this.button = this.querySelector(".m-image-comparison__button");
      this.horizontal = this.dataset.layout === "horizontal";

      if (!this.button) return;

      this.start = this.start.bind(this);
      this.end = this.end.bind(this);
      this.onMove = this.onMove.bind(this);

      this.init();

      if (this.hasAttribute("data-animation") && window.MinimogTheme) {
        MinimogTheme.initWhenVisible({
          element: this.querySelector(".m-image-comparison__slider-animation"),
          callback: this.animation.bind(this),
          threshold: 0,
        });
      }
    }

    init() {
      // Mouse
      this.button.addEventListener("mousedown", this.start);

      // Touch
      this.button.addEventListener(
        "touchstart",
        this.start,
        { passive: false }
      );

      // Window events
      window.addEventListener("mousemove", this.onMove);
      window.addEventListener(
        "touchmove",
        this.onMove,
        { passive: false }
      );

      window.addEventListener("mouseup", this.end);
      window.addEventListener("mouseleave", this.end);
      window.addEventListener("touchend", this.end);
      window.addEventListener("touchcancel", this.end);
    }

    animation() {
      this.setAttribute("is-visible", "");
      this.classList.add("m-animating");

      setTimeout(() => {
        this.classList.remove("m-animating");
      }, 1000);
    }

    start(e) {
      e.preventDefault();
      e.stopPropagation();

      this.active = true;

      document.documentElement.classList.add("prevent-scroll");
      this.classList.add("image-comparing");

      // Disable Swiper dragging while comparing
      const swiperEl = this.closest(".swiper");
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = false;
      }
    }

    end() {
      if (!this.active) return;

      this.active = false;

      document.documentElement.classList.remove("prevent-scroll");
      this.classList.remove("image-comparing");

      // Re-enable Swiper
      const swiperEl = this.closest(".swiper");
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = true;
      }
    }

    onMove(e) {
      if (!this.active) return;

      e.preventDefault();
      e.stopPropagation();

      const event = e.touches ? e.touches[0] : e;

      const rect = this.getBoundingClientRect();

      let position;

      if (this.horizontal) {
        position = event.clientX - rect.left;
      } else {
        position = event.clientY - rect.top;
      }

      this.scroll(position);
    }

    scroll(position) {
      const distance = this.horizontal
        ? this.clientWidth
        : this.clientHeight;

      const min = 20;
      const max = distance - 20;

      position = Math.max(min, Math.min(position, max));

      const percent = (position / distance) * 100;

      this.style.setProperty("--percent", percent + "%");
    }
  }

  customElements.define("m-image-comparison", MImageComparison);
}